import MDModal from "components/MDModal";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useContext, useEffect, useState } from "react";
import DataTable from "examples/Tables/DataTable";
import DefaultCell from "examples/Tables/DataTable/components/DefaultCell";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import { ModalContext } from "context/ModalContext";
import { LoginFormContext } from "context/LoginFormContext";
import { advertisementList } from "Apis/advertisement";
import { getAdvertisementById } from "Apis/advertisement";
import { deleteAdvertisementById } from "Apis/advertisement";
import { MODULES } from "helpers/constant";
import AdvertisementForm from "./Form";
import { AdvertisementContext } from "context/AdvertisementContext";
import UpdateStatus from "components/MDUpdateStatus";
import advertisement from "../../../assets/images/placeholder.jpg";
import MDActionButton from "components/MDActionButton";
import colors from "assets/theme/base/colors";
import Imagepreview from "components/MDImagePreview";
import { SEARCH_INPUT_TYPES } from "helpers/constant";
import moment from "moment";

const Advertisement = () => {
  const { showMessageNotification, setOpen, formIsEdit, setFormIsEdit } = useContext(ModalContext);
  const {
    setNotification,
    modules,
    getModuleAccess,
    access,
    isLoading,
    setIsLoading,
    filterLoader,
    setFilterLoader,
  } = useContext(LoginFormContext);
  const { setEditData } = useContext(AdvertisementContext);
  const [advertiseData, setAdvertiseData] = useState([]);
  const { imageBorder } = colors;
  const [rowCount, setRowCount] = useState(0);
  const [defaultFilter, setDefaultFilter] = useState({
    currentPage: 1,
    itemsPerPage: 10,
    sortBy: [{ id: "id", value: "desc" }],
  });

  const handleEditDelete = async (row, type) => {
    if (type === "Edit") {
      setFilterLoader(false);
      let response = await getAdvertisementById(row.id);
      if (response?.status === 200) {
        setEditData(response?.data?.data);
        setOpen(true);
        setFormIsEdit(true);
      }
    }

    if (type === "Delete") {
      showMessageNotification({
        title: "Are you sure?",
        text: "You want to delete this advertisement!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result?.isConfirmed) {
          let deleteResponse = await deleteAdvertisementById(row.id);
          if (deleteResponse?.status === 200) {
            setFilterLoader(false);
            setOpen(false);
            advertiseData?.length === 1 && setDefaultFilter({ ...defaultFilter, currentPage: 1 });
            getAdvertisementList();
            setNotification({
              color: "success",
              icon: "check",
              title: "Success",
              content: deleteResponse?.data?.message,
              open: true,
            });
          } else {
            setNotification({
              color: "error",
              icon: "check",
              title: "error",
              content: deleteResponse?.data?.message,
              open: true,
            });
          }
        }
      });
    }
  };

  const [filterVal, setFilterVal] = useState({
    title: "",
    link: "",
  });

  const handleFilter = (accessor, value) => {
    setFilterLoader(true);
    setFilterVal({ ...filterVal, [accessor]: value });
    setDefaultFilter((prev) => ({ ...prev, currentPage: 1 }));
  };

  let Obj = {
    ...defaultFilter,
    filters: {
      title: filterVal.title,
      page: filterVal.page,
      is_active: filterVal?.is_active?.value,
    },
  };

  const getAdvertisementList = async (data) => {
    let response = await advertisementList(Obj);
    filterLoader ? setIsLoading(false) : setIsLoading(true);
    if (response?.status === 200) {
      setIsLoading(false);
      setAdvertiseData(response?.data?.data?.rows);
      setRowCount(response?.data?.data?.count);
    }
  };

  useEffect(() => {
    getModuleAccess(MODULES.ADVERTISEMENTS);
  }, [modules]);

  useEffect(() => {
    getAdvertisementList();
  }, [filterVal, defaultFilter]);

  const [selectedImage, setSelectedImage] = useState(null);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setIsImageModalOpen(true);
  };

  let data = {
    isFilter: true,
    columns: [
      {
        Header: "Title",
        accessor: "title",
        minWidth: "85px",
        sort: true,
        filterLabel: "Title",
        filterAccessor: "title",
        filterInputType: SEARCH_INPUT_TYPES.TEXT,
        filterHandleChange: handleFilter,
        Cell: ({ value, row }) => {
          const imageUrl = row?.original?.advertisement_images[0]?.image;

          const [imgError, setImgError] = React.useState(false);

          return (
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              {imageUrl && !imgError ? (
                <img
                  src={imageUrl}
                  alt="image"
                  onError={() => setImgError(true)}
                  onClick={() => handleImageClick(imageUrl)}
                  style={{
                    height: "50px",
                    width: "50px",
                    borderRadius: "100%",
                    objectFit: "cover",
                    border: `1px solid ${imageBorder.borderColor}`,
                    cursor: "pointer",
                  }}
                />
              ) : (
                <img
                  src={advertisement}
                  alt="image"
                  style={{
                    height: "50px",
                    width: "50px",
                    borderRadius: "100%",
                    objectFit: "fill",
                    border: `1px solid ${imageBorder.borderColor}`,
                  }}
                />
              )}
              <DefaultCell value={value || "-"} />
            </div>
          );
        },
      },
      {
        Header: "Page",
        accessor: "page",
        minWidth: "85px",
        sort: true,
        filterLabel: "Page",
        filterAccessor: "page",
        filterInputType: SEARCH_INPUT_TYPES.TEXT,
        filterHandleChange: handleFilter,
        Cell: ({ value }) => <DefaultCell value={value ? value : "-"} />,
      },
      {
        Header: "Created date",
        accessor: "createdAt",
        sort: true,
        Cell: ({ value }) => (
          <DefaultCell value={value ? moment(value).format("DD-MM-YYYY hh:mm A") : "-"} />
        ),
      },
      {
        Header: "Status",
        accessor: "is_active",
        minWidth: "115px",
        filterLabel: "Status",
        filterAccessor: "is_active",
        filterInputType: SEARCH_INPUT_TYPES.AUTO_COMPLETE,
        filterHandleChange: handleFilter,
        filterOption: [
          { label: "Active", value: "1" },
          { label: "Inactive", value: "0" },
        ],
        Cell: ({ row }) => (
          <UpdateStatus
            tableNameProp="advertisements"
            data={row}
            access={access?.write_access ? true : false}
          />
        ),
      },
      {
        Header: "Action",
        accessor: "action",
        width: "12%",
        Cell: ({ value, row }) => (
          <MDBox sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
            {access?.write_access && (
              <MDActionButton type="edit" onClick={() => handleEditDelete(row?.original, "Edit")} />
            )}
            {access?.delete_access && (
              <MDActionButton
                type="delete"
                onClick={() => handleEditDelete(row?.original, "Delete")}
              />
            )}
          </MDBox>
        ),
      },
    ],
    rows: advertiseData,
  };

  return (
    !isLoading && (
      <DashboardLayout>
        <DashboardNavbar />
        <>
          <MDModal
            hasButton={access?.write_access ?? false}
            btnText="Add Advertisement"
            modalHead={`${formIsEdit ? "Edit" : "Add"} Advertisement`}
          >
            <AdvertisementForm getAdvertisementList={getAdvertisementList} />
          </MDModal>
          <DataTable
            table={data}
            isSorted={false}
            entriesPerPage={true}
            showTotalEntries={true}
            noEndBorder
            canFilter
            canSearch={true}
            rowCount={rowCount}
            getDataList={getAdvertisementList}
            tableTitle="Advertisement List"
            defaultFilter={defaultFilter}
            setDefaultFilter={setDefaultFilter}
          />
          {selectedImage && (
            <Imagepreview
              open={isImageModalOpen}
              onClose={() => setIsImageModalOpen(false)}
              imageUrl={selectedImage}
            />
          )}
        </>
      </DashboardLayout>
    )
  );
};

Advertisement.propTypes = {
  value: PropTypes.string,
  row: PropTypes.string,
  getAdvertisementList: PropTypes.func,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  imageUrl: PropTypes.string.isRequired,
};

export default Advertisement;
